import * as Yup from 'yup';

export const GovIdUploadSchema = Yup.object().shape({
    governmentId: Yup.mixed()
      .nullable()
      .test('fileFormat', 'Unsupported file format', (value) => {
        if (!value) return true; // allow null or undefined
        return value instanceof File;
      })
      .test('fileSize', 'File size must not exceed 3MB', (value) => {
        if (!value) return true; // allow null or undefined
        return value instanceof File && value.size <= 3 * 1024 * 1024;
      }),
  });
  
 export  type GovIdUploadDataType = Yup.InferType<typeof GovIdUploadSchema>;
  
  type InitialValues = {
    governmentId?: any;
  };
  
 export const GovIdUploadInitialValues: InitialValues = {
    governmentId: null,
  };
  